// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../resources/images/ico-poncho-512x512-2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilo para el fondo semitransparente que cubre toda la pantalla */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(
    255,
    255,
    255,
    0.6
  ); /* Fondo claro semitransparente */
  z-index: 9999; /* Coloca el fondo por encima de otros elementos */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Estilo para el contenedor del componente de carga */
.loading-div {
  width: 150px;
  height: 150px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000; /* Coloca el componente Loading por encima del fondo */
}

/* Spinner: ícono poncho con animación de latido y cambio de tono */
.spinner {
  width: 80px;
  height: 80px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    center / contain no-repeat;
  animation: heartBeatColor 2.4s infinite;
}

@keyframes heartBeatColor {
  0% {
    transform: scale(1);
    filter: hue-rotate(0deg);
    opacity: 0.8;
  }

  14% {
    transform: scale(1.15);
  }

  28% {
    transform: scale(0.95);
  }

  42% {
    transform: scale(1.1);
    filter: hue-rotate(180deg);
    opacity: 1;
  }

  70% {
    transform: scale(1);
    filter: hue-rotate(360deg);
    opacity: 0.85;
  }

  100% {
    transform: scale(1);
    opacity: 0.8;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Loading/loading.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC,EAAE,iCAAiC;EACpC,aAAa,EAAE,kDAAkD;EACjE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc,EAAE,sDAAsD;AACxE;;AAEA,mEAAmE;AACnE;EACE,WAAW;EACX,YAAY;EACZ;8BAC4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE;IACE,mBAAmB;IACnB,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;AACF","sourcesContent":["/* Estilo para el fondo semitransparente que cubre toda la pantalla */\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(\n    255,\n    255,\n    255,\n    0.6\n  ); /* Fondo claro semitransparente */\n  z-index: 9999; /* Coloca el fondo por encima de otros elementos */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Estilo para el contenedor del componente de carga */\n.loading-div {\n  width: 150px;\n  height: 150px;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10000; /* Coloca el componente Loading por encima del fondo */\n}\n\n/* Spinner: ícono poncho con animación de latido y cambio de tono */\n.spinner {\n  width: 80px;\n  height: 80px;\n  background: url('../../resources/images/ico-poncho-512x512-2.png')\n    center / contain no-repeat;\n  animation: heartBeatColor 2.4s infinite;\n}\n\n@keyframes heartBeatColor {\n  0% {\n    transform: scale(1);\n    filter: hue-rotate(0deg);\n    opacity: 0.8;\n  }\n\n  14% {\n    transform: scale(1.15);\n  }\n\n  28% {\n    transform: scale(0.95);\n  }\n\n  42% {\n    transform: scale(1.1);\n    filter: hue-rotate(180deg);\n    opacity: 1;\n  }\n\n  70% {\n    transform: scale(1);\n    filter: hue-rotate(360deg);\n    opacity: 0.85;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 0.8;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
